import { FormControl } from 'bold-ui'
import { SwitchField, SwitchFieldProps } from 'components/form'
import { resolveName } from 'components/form/final-form/useField'
import React from 'react'
import { useField } from 'react-final-form'

export interface NecessidadesEspeciaisFieldProps extends Omit<SwitchFieldProps, 'label'> {
  label: string
}

export function NecessidadesEspeciaisField(props: NecessidadesEspeciaisFieldProps) {
  const { label, name, ...rest } = props

  const {
    input: { value: necessidadesEspeciais },
  } = useField(resolveName(name), { subscription: { value: true } })

  return (
    <FormControl label={label}>
      <SwitchField name={name} label={necessidadesEspeciais ? 'Sim' : 'Não'} {...rest} />
    </FormControl>
  )
}
